import services from "../services";

export const ActionCreate = async ({_}, payload) => {
    const { data } = await services.create(payload)
    if (data.error === false) {
        return Promise.resolve(data);
    }
    return Promise.reject(data);
}